/* src/routes/blog/3d-printing.svelte generated by Svelte v3.32.3 */
import {
	SvelteComponent,
	claim_component,
	claim_space,
	claim_text,
	create_component,
	destroy_component,
	detach,
	init,
	insert,
	mount_component,
	noop,
	safe_not_equal,
	space,
	text,
	transition_in,
	transition_out
} from "../../../_snowpack/pkg/svelte/internal.js";

import Gallery from "../../../_components/Gallery.svelte.js";
import PostTop from "../../../_components/Post-Top.svelte.js";
import PostContents from "../../../_components/Post-Contents.svelte.js";
import PostSection from "../../../_components/Post-Section.svelte.js";

function create_default_slot_3(ctx) {
	let t;
	let gallery;
	let current;

	gallery = new Gallery({
			props: { images: /*photos_cube*/ ctx[2] }
		});

	return {
		c() {
			t = text("As you can see the auto leveling has now stopped my prints from leaning to\n    one side:\n    ");
			create_component(gallery.$$.fragment);
		},
		l(nodes) {
			t = claim_text(nodes, "As you can see the auto leveling has now stopped my prints from leaning to\n    one side:\n    ");
			claim_component(gallery.$$.fragment, nodes);
		},
		m(target, anchor) {
			insert(target, t, anchor);
			mount_component(gallery, target, anchor);
			current = true;
		},
		p: noop,
		i(local) {
			if (current) return;
			transition_in(gallery.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(gallery.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(t);
			destroy_component(gallery, detaching);
		}
	};
}

// (37:2) <PostSection title=" Elephant.">
function create_default_slot_2(ctx) {
	let gallery;
	let current;

	gallery = new Gallery({
			props: { images: /*photos_elephant*/ ctx[3] }
		});

	return {
		c() {
			create_component(gallery.$$.fragment);
		},
		l(nodes) {
			claim_component(gallery.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(gallery, target, anchor);
			current = true;
		},
		p: noop,
		i(local) {
			if (current) return;
			transition_in(gallery.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(gallery.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(gallery, detaching);
		}
	};
}

// (41:2) <PostSection title="Octopus">
function create_default_slot_1(ctx) {
	let gallery;
	let current;

	gallery = new Gallery({
			props: { images: /*photos_octopus*/ ctx[4] }
		});

	return {
		c() {
			create_component(gallery.$$.fragment);
		},
		l(nodes) {
			claim_component(gallery.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(gallery, target, anchor);
			current = true;
		},
		p: noop,
		i(local) {
			if (current) return;
			transition_in(gallery.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(gallery.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(gallery, detaching);
		}
	};
}

// (28:0) <PostContents>
function create_default_slot(ctx) {
	let t0;
	let postsection0;
	let t1;
	let postsection1;
	let t2;
	let postsection2;
	let current;

	postsection0 = new PostSection({
			props: {
				title: "Calibration Cube.",
				$$slots: { default: [create_default_slot_3] },
				$$scope: { ctx }
			}
		});

	postsection1 = new PostSection({
			props: {
				title: " Elephant.",
				$$slots: { default: [create_default_slot_2] },
				$$scope: { ctx }
			}
		});

	postsection2 = new PostSection({
			props: {
				title: "Octopus",
				$$slots: { default: [create_default_slot_1] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			t0 = text("I Haven't had much spare time to post any updates lately. Here are some prints\n  that have been done with my printer\n  ");
			create_component(postsection0.$$.fragment);
			t1 = space();
			create_component(postsection1.$$.fragment);
			t2 = space();
			create_component(postsection2.$$.fragment);
		},
		l(nodes) {
			t0 = claim_text(nodes, "I Haven't had much spare time to post any updates lately. Here are some prints\n  that have been done with my printer\n  ");
			claim_component(postsection0.$$.fragment, nodes);
			t1 = claim_space(nodes);
			claim_component(postsection1.$$.fragment, nodes);
			t2 = claim_space(nodes);
			claim_component(postsection2.$$.fragment, nodes);
		},
		m(target, anchor) {
			insert(target, t0, anchor);
			mount_component(postsection0, target, anchor);
			insert(target, t1, anchor);
			mount_component(postsection1, target, anchor);
			insert(target, t2, anchor);
			mount_component(postsection2, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const postsection0_changes = {};

			if (dirty & /*$$scope*/ 32) {
				postsection0_changes.$$scope = { dirty, ctx };
			}

			postsection0.$set(postsection0_changes);
			const postsection1_changes = {};

			if (dirty & /*$$scope*/ 32) {
				postsection1_changes.$$scope = { dirty, ctx };
			}

			postsection1.$set(postsection1_changes);
			const postsection2_changes = {};

			if (dirty & /*$$scope*/ 32) {
				postsection2_changes.$$scope = { dirty, ctx };
			}

			postsection2.$set(postsection2_changes);
		},
		i(local) {
			if (current) return;
			transition_in(postsection0.$$.fragment, local);
			transition_in(postsection1.$$.fragment, local);
			transition_in(postsection2.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(postsection0.$$.fragment, local);
			transition_out(postsection1.$$.fragment, local);
			transition_out(postsection2.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(t0);
			destroy_component(postsection0, detaching);
			if (detaching) detach(t1);
			destroy_component(postsection1, detaching);
			if (detaching) detach(t2);
			destroy_component(postsection2, detaching);
		}
	};
}

function create_fragment(ctx) {
	let posttop;
	let t;
	let postcontents;
	let current;

	posttop = new PostTop({
			props: {
				title,
				tags: /*tags*/ ctx[0],
				projects: /*projects*/ ctx[1]
			}
		});

	postcontents = new PostContents({
			props: {
				$$slots: { default: [create_default_slot] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(posttop.$$.fragment);
			t = space();
			create_component(postcontents.$$.fragment);
		},
		l(nodes) {
			claim_component(posttop.$$.fragment, nodes);
			t = claim_space(nodes);
			claim_component(postcontents.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(posttop, target, anchor);
			insert(target, t, anchor);
			mount_component(postcontents, target, anchor);
			current = true;
		},
		p(ctx, [dirty]) {
			const postcontents_changes = {};

			if (dirty & /*$$scope*/ 32) {
				postcontents_changes.$$scope = { dirty, ctx };
			}

			postcontents.$set(postcontents_changes);
		},
		i(local) {
			if (current) return;
			transition_in(posttop.$$.fragment, local);
			transition_in(postcontents.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(posttop.$$.fragment, local);
			transition_out(postcontents.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(posttop, detaching);
			if (detaching) detach(t);
			destroy_component(postcontents, detaching);
		}
	};
}

const title = "3D Printer 5 - Prints";
const date = "2014-08-07 14:35:54";

function instance($$self) {
	const tags = ["hardware"];
	const projects = ["3D-Printer"];

	const photos_cube = [
		"/content/blog/images/3d-printing/cube_a.jpg",
		"/content/blog/images/3d-printing/cube_b.jpg",
		"/content/blog/images/3d-printing/cube_c.jpg"
	];

	const photos_elephant = [
		"/content/blog/images/3d-printing/elephant_a.jpg",
		"/content/blog/images/3d-printing/elephant_b.jpg"
	];

	const photos_octopus = [
		"/content/blog/images/3d-printing/octopus_a.jpg",
		"/content/blog/images/3d-printing/octopus_b.jpg",
		"/content/blog/images/3d-printing/octopus_c.jpg"
	];

	return [tags, projects, photos_cube, photos_elephant, photos_octopus];
}

class _3d_printing extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, {});
	}
}

export default _3d_printing;
//# sourceMappingURL=3d-printing.svelte.js.map
